export default "__VITE_ASSET__Cjj2l8DQ__"